<div *ngIf="errors && !readOnly">
    <!--REQUIRED-->
    <p *ngIf="errors.required" class="error">
        {{ 'ERRORS.FORMS.REQUIRED' | translate }}
    </p>

    <!--MAX LENGTH-->
    <p *ngIf="errors.maxlength" class="error">
        {{ 'ERRORS.FORMS.MAX-LENGTH' | translate }}
    </p>
    <p *ngIf="errors.maxlength && data" class="error">{{ 'ERRORS.FORMS.MAX-LENGTH-DATA' | translate }} {{ data }}</p>

    <!--EMAIL-->
    <p *ngIf="errors.email" class="error">
        {{ 'ERRORS.FORMS.EMAIL' | translate }}
    </p>

    <!--WRONG NUMBER-->
    <p *ngIf="errors.wrongNumber" class="error">
        {{ 'ERRORS.FORMS.PHONE-NUMBER' | translate }}
    </p>

    <!--PATTERN-->
    <p *ngIf="errors.pattern" class="error">
        {{ 'ERRORS.FORMS.PATTERN' | translate }}
    </p>

    <!--WRONG DELAYS-->
    <p *ngIf="errors.wrongDelays" class="error">
        {{ 'ERRORS.FORMS.DELAYS-COMPARISON' | translate }}
    </p>

    <!--WRONG LOGIN-->
    <p *ngIf="errors.wrongLogin" class="error">
        {{ 'ERRORS.HTTP.MESSAGES.INCORRECT-LOGIN' | translate }}
    </p>

    <!--WRONG PASSWORD-->
    <p *ngIf="errors.wrongPassword" class="error">
        {{ 'ERRORS.HTTP.MESSAGES.INCORRECT-PASSWORD' | translate }}
    </p>

    <p *ngIf="errors.wrongFormat" class="error">
        {{ 'ERRORS.FORMS.PWD_FORMAT' | translate }}
    </p>

    <p *ngIf="errors.samePassword" class="error">
        {{ 'ERRORS.FORMS.SAME_PASSWORD' | translate }}
    </p>

    <p *ngIf="errors.nonEqualFields" class="error">
        {{ 'ERRORS.FORMS.WRONG-PWD-EQUALITY' | translate }}
    </p>

    <p *ngIf="errors.passwordError" class="error">
        {{ 'ERRORS.FORMS.PWD_ERROR' | translate }}
    </p>

    <p *ngIf="errors.missingPassword" class="error">
        {{ 'ERRORS.FORMS.MISSING_PWD' | translate }}
    </p>

    <!--WRONG HOURS-->
    <p *ngIf="errors.wrongHours" class="error">
        {{ 'ERRORS.FORMS.HOURS' | translate }}
    </p>

    <!--MIN VALUE-->
    <p *ngIf="errors.min" class="error">{{ 'ERRORS.FORMS.MINIMUM' | translate }} {{ '(' + errors.min.min + ')' }}</p>

    <!-- STRIPE -->
    <p *ngIf="errors.wrongStripeKeyFormat" class="error">
        {{ 'ERRORS.FORMS.STRIPE_FORMAT' | translate }}
    </p>

    <!-- SIGNATURE FILE REQUIRED  -->
    <p *ngIf="errors.schoolSignatureRequired" class="error">
        {{ 'ERRORS.FORMS.TAX_SIGNATURE_REQUIRED' | translate }}
    </p>

    <!--ADD OTHER ERRORS CODES-->
</div>
